import API from '../../../utils/http/api'
import {createSelector} from "reselect"

// Actions
const REQUEST = "steppingblocks/contactus/REQUEST"
const SUCCESS = "steppingblocks/contactus/SUCCESS"
const FAILURE = "steppingblocks/contactus/FAILURE"
const OPEN = 'steppingblocks/contactus/OPEN'
const CLOSE = 'steppingblocks/contactus/CLOSE'

const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  isShowingModal: false,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    case OPEN:
      return { ..._state, isShowingModal: true }
    case CLOSE:
      return { ..._state, isShowingModal: false }
    default:
      return _state
  }
}

export const openModal = () => ({ type: OPEN })

export const closeModal = () => ({ type: CLOSE })

export const performContactUs = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    await API.post('/users/contact-us', params)
    dispatch({ type: SUCCESS })
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw error
  }
}

const baseKey = state => state.contactUs

export const getIsShowingModal = createSelector(
  baseKey,
  data => data.isShowingModal,
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/contactUsDuck.js